import { h } from 'preact'
import Icon from '../../preact-components/assets'
import Tooltip from './Tooltip'

export default ({ title } : { title: string }) => {
  if (!title) return null
  return <Tooltip trigger={<Icon icon={'question'} height={16} width={16} />} tooltipMessage={title} />
}
